import { mode } from "@chakra-ui/theme-tools";
import { DateObject } from "react-multi-date-picker";

export const globalStyles = {
  colors: {
    gray: {
      700: "#1f2733",
    },
  },
  styles: {
    global: (props) => ({
      body: {
        bg: "background",
        color: "text",
        fontFamily: "'Shabnam','Roboto', sans-serif",
      },
      html: {
        fontFamily: "'Shabnam','Roboto', sans-serif",
      },
    }),
  },
};

export const formatNumber = (string_number) => {
  let price = string_number.toString().replace(/,/g, "");
  return price.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
/* export const removeFormat = (string_number) => {
  return string_number.replace(/,/g, "");
}; */
export const removeFormat = (value) => {
  if (value === null || value === undefined || value === "") {
    return "";
  }

  return String(value).replace(/,/g, "");
};

export const getCurrectedTime = (dateTime) => {
  let cdtime = new Date(dateTime);
  cdtime.setMinutes(cdtime.getMinutes() - cdtime.getTimezoneOffset());
  return cdtime.toISOString();
};

export const handleZeroTextFocus = (e) => {
  if (e.target.value === "0") e.target.select();
};

export const getLastMonth = () => {
  let today = new Date();
  today.setMonth(today.getMonth() - 1);
  return today;
};

export const getFromDatePickerDateTime = (value) => {
  const cdtime = new Date(value);
  cdtime.setHours(0, 0, 0);
  cdtime.setMinutes(cdtime.getMinutes() - cdtime.getTimezoneOffset());
  return cdtime.toISOString();
};
export const getToDatePickerDateTime = (value) => {
  let cdtime = new Date(value);
  cdtime.setHours(23, 59, 59);
  cdtime.setMinutes(cdtime.getMinutes() - cdtime.getTimezoneOffset());
  return cdtime.toISOString();
};
